import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  onTotalsChange,
  setTotalOrderFromOrders,
  setDeliveredCountFromOrders,
  setUndeliveredOrdersFromOrders,
  setAmountFromOrders,
}) {
  const [dataFilter, setDataFilter] = useState("");
  const [hubFilter, setHubFilter] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [vehicleFilter, setVehicleFilter] = useState("");
  const [clientFilter, setClientFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const pageSize = 10;

  // ✅ Utility: Convert date to IST YYYY-MM-DD
  const formatDateToIST = (date) => {
    return new Date(date).toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    });
  };

  // ✅ Set default date range to current month in IST
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0 = Jan
    const firstDay = formatDateToIST(new Date(year, month, 1));
    const lastDay = formatDateToIST(new Date(year, month + 1, 0));

    setFromDate(firstDay);
    setToDate(lastDay);
  }, []);

  const fetchOrders = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("resultPerPage", rowsPerPage);

      if (hubFilter) params.append("id_hub", hubFilter);
      if (userFilter) params.append("id_user", userFilter);
      if (vehicleFilter) params.append("id_vehicle", vehicleFilter);
      if (clientFilter) params.append("id_client", clientFilter);
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);

      const endpoint = `${
        process.env.REACT_APP_BASE_URL
      }/api/v1/orders?${params.toString()}`;

      const response = await axios.get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        const orders = response.data.orders || [];
        let filteredOrders = orders;

        // ✅ Local search filter
        if (dataFilter) {
          const searchValue = dataFilter.toLowerCase();
          filteredOrders = filteredOrders.filter((item) => {
            const name = item?.name?.toLowerCase() || "";
            const userName = item?.id_user?.name?.toLowerCase() || "";
            const numberplate =
              item?.id_vehicle?.numberplate?.toLowerCase() || "";
            return (
              name.includes(searchValue) ||
              userName.includes(searchValue) ||
              numberplate.includes(searchValue)
            );
          });
        }

        setFilteredData(filteredOrders);

        // ✅ Ensure totalRecords matches backend field
        setTotalRecords(response.data.totalOrders || response.data.count || 0);

        // ✅ Update summary if available
        if (response.data.summary) {
          const {
            totalOrders,
            totalDelivered,
            totalUndelivered,
            totalAmounts,
            totalCancelAmount,
            totalMissedAmount,
          } = response.data.summary;
          const netAmount =
            Number(totalAmounts) -
            (Number(totalCancelAmount || 0) + Number(totalMissedAmount || 0));
          setTotalOrderFromOrders(totalOrders);
          setDeliveredCountFromOrders(totalDelivered);
          // setAmountFromOrders(totalAmounts);
          setAmountFromOrders(netAmount);

          setUndeliveredOrdersFromOrders(totalUndelivered || 0);
        } else {
          console.error("Summary data is missing in API response.");
        }
      } else {
        console.error("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // ✅ Fetch orders whenever filters or search change
  useEffect(() => {
    if (fromDate && toDate) {
      fetchOrders(1);
    }
  }, [
    hubFilter,
    userFilter,
    vehicleFilter,
    clientFilter,
    fromDate,
    toDate,
    dataFilter,
    rowsPerPage,
  ]);

  const handlePageChange = (page) => {
    fetchOrders(page);
  };

  const applyFilters = () => {
    setShowFilterModal(false);
    fetchOrders(1);
  };

  const removeFilters = () => {
    setShowFilterModal(false);
    setClientFilter("");
    setHubFilter("");
    setVehicleFilter("");
    setUserFilter("");

    // Reset to current month in IST
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDay = formatDateToIST(new Date(year, month, 1));
    const lastDay = formatDateToIST(new Date(year, month + 1, 0));
    setFromDate(firstDay);
    setToDate(lastDay);
    setDataFilter("");
    fetchOrders(1);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        fixedHeader
        highlightOnHover
        responsive
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationServer
        onChangePage={handlePageChange}
        paginationTotalRows={totalRecords}
        onChangeRowsPerPage={(newPerPage, page) => {
          setRowsPerPage(newPerPage);
          fetchOrders(1);
        }}
      />
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        clientFilter={clientFilter}
        setClientFilter={setClientFilter}
        vehicleFilter={vehicleFilter}
        setVehicleFilter={setVehicleFilter}
        userFilter={userFilter}
        setUserFilter={setUserFilter}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
      />
    </div>
  );
}
